var Afterpay = {
    supportedTheme: !1,
    mutationObserver: !1,
    arrayContainsElement: function (t, e) {
        var a;
        if (Array.prototype.indexOf) return -1 < t.indexOf(e);
        for (a = 0; a < t.length; a++)
            if (t[a] == e) return !0;
        return !1
    },
    closePopup: function (t, e) {
        e.preventDefault(), t("#afterpay-popup-wrapper").hide()
    },
    commonElements: {
        product: {
            price_selector: ["#ProductPrice", "#product-price", "#ProductSection .product-single__prices", ".product-details .product-price", ".product--container .product-pricing", ".productForm .product-price", ".product-single__meta .product__price", ".product__content .product__price", "p.modal_price", "ul.product-meta", "ul.product-single__meta-list", ".product-single__price", ".product-single__prices", ".product__price", ".price", ".prices", ".product_price", ".modal_price"]
        },
        cart: {
            static_page: {
                subtotal_selector: ["#CartSubtotal", "form .subtotal_amount", ".cart__footer .cart__subtotal", ".cart-footer .cart-footer__subtotal", "span.cart__subtotal", ".h1.cart-subtotal--price", ".cart__row--table:last", ".cart-subtotal"]
            }
        },
        footer: {
            logo_container: ["footer ul.payment-icons", "footer div.payment-methods__inner", "footer .payment-options", "footer ul.payment-icons--list", "footer .payment-types ul", "footer .site-footer-payment-types", "footer #payment", "footer ul.payment-icon-list", ".footer .payment_methods", "footer ul.Footer__PaymentList", "footer .payment-types", ".page-footer ul.payment-methods", "#pagefooter .payment-methods", "footer ul.footer__icons-items", "footer div.payment_methods", "footer div.payment-methods"]
        }
    },
    extractPriceFromHTML: function (t) {
        t = t.replace(/[^0-9.]/g, "");
        return Math.round(100 * parseFloat(t))
    },
    generateCurrencyHTML: function (t) {
        t = Math.round(t, 2), t = afterpay_hide_range_decimals ? t.toFixed(0) : t.toFixed(2);
        return afterpay_show_currency_code ? "$" + t + "&nbsp;" + afterpay_shop_currency.toUpperCase() : "$" + t
    },
    generateInsideLimitHTML: function (t) {
        return t.data("outsidePaymentLimits") && (t.removeData("outsidePaymentLimits"), Afterpay.supportedTheme ? t.find(".afterpay-text1").html("or 4 interest-free installments of ") : t.find(".afterpay-text1").html("Pay in 4 interest-free installments of "), t.find(".afterpay-logo").insertAfter(t.find(".afterpay-instalments")), t.find(".afterpay-text2").html(" by ").insertBefore(t.find(".afterpay-logo")), t.find(".afterpay-link-inner").html(afterpay_modal_open_icon ? "â“˜" : '<i class="fa fa-info-circle" aria-hidden="true"></i>')), t
    },
    generateInstalmentHTML: function (t) {
        t = (Math.round(t / 4) / 100).toFixed(2);
        return afterpay_show_currency_code ? "$" + t + "&nbsp;" + afterpay_shop_currency.toUpperCase() : "$" + t
    },
    generateOutsideLimitHTML: function (t) {
        return t.data("outsidePaymentLimits", !0), Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.2", ">=") ? t.find(".afterpay-text1").html("") : t.find(".afterpay-text1").html("Interest-free installments by "), t.find(".afterpay-logo").insertAfter(t.find(".afterpay-text1")), afterpay_hide_upper_limit && !afterpay_hide_lower_limit ? (t.find(".afterpay-text2").html(" available for orders over "), t.find(".afterpay-instalments").html(Afterpay.generateCurrencyHTML(afterpay_min)).insertAfter(t.find(".afterpay-text2"))) : !afterpay_hide_upper_limit && afterpay_hide_lower_limit ? (t.find(".afterpay-text2").html(" available for orders up to "), t.find(".afterpay-instalments").html(Afterpay.generateCurrencyHTML(afterpay_max)).insertAfter(t.find(".afterpay-text2"))) : (!afterpay_hide_upper_limit && !afterpay_hide_lower_limit || afterpay_hide_upper_limit && afterpay_hide_lower_limit) && (t.find(".afterpay-text2").html(" available between "), t.find(".afterpay-instalments").html(Afterpay.generateCurrencyHTML(afterpay_min) + " - " + Afterpay.generateCurrencyHTML(afterpay_max)).insertAfter(t.find(".afterpay-text2"))), t.find(".afterpay-link-inner").html(afterpay_modal_open_icon ? "â“˜" : '<i class="fa fa-info-circle" aria-hidden="true"></i>'), t
    },
    init: function (c) {
        Afterpay.supportedTheme = Afterpay.supportedThemes[afterpay_theme_name.toLowerCase()], Afterpay.mutationObserver = window.MutationObserver || window.WebKitMutationObserver, /^\/cart/i.test(window.location.pathname) ? 0 != afterpay_cart_integration_enabled && Afterpay.initStaticCartPage(c) : /^\/(collections|products)/i.test(window.location.pathname) && afterpay_product && afterpay_product_integration_enabled && Afterpay.initProductPage(c), Afterpay.initFooterLogo(c), 0 != afterpay_cart_dynamic_integration_enabled && Afterpay.supportedTheme && Afterpay.supportedTheme.hasOwnProperty("cart") && Afterpay.supportedTheme.cart.hasOwnProperty("dynamic_content") && c.each(Afterpay.supportedTheme.cart.dynamic_content, function (t, p) {
            p.hasOwnProperty("target_selector") && p.hasOwnProperty("addedNode_selector") && p.hasOwnProperty("subtotal_selector") && (Afterpay.mutationObserver && new Afterpay.mutationObserver(function (t, e) {
                for (var a, o, r = 0; r < t.length; r++)
                    if (c(t[r].target).is(p.target_selector))
                        for (a = 0; a < t[r].addedNodes.length; a++) "object" == typeof t[r].addedNodes[a] && c(t[r].addedNodes[a]).is(p.addedNode_selector) && (o = Afterpay.renderParagraph(c, {
                            total_price: afterpay_cart_total_price,
                            page_name: "dynamic_cart"
                        }), "USD" != afterpay_shop_currency && (o.find(".afterpay-text1").html("or 4 payments of "), o.find(".afterpay-text2").html(" with ")), (afterpay_cart_total_price < 100 * afterpay_min || afterpay_cart_total_price > 100 * afterpay_max) && ("USD" == afterpay_shop_currency ? o = Afterpay.generateOutsideLimitHTML(o) : o.hide()), "undefined" != typeof afterpay_cart_dynamic_css && o.css(afterpay_cart_dynamic_css), c(p.target_selector).find(p.addedNode_selector).find(p.subtotal_selector).after(o), p.paragraph_css && o.css(p.paragraph_css), $logo_element = o.find(".afterpay-logo"), 0 < $logo_element.length && p.logo_css && $logo_element.css(p.logo_css), "function" == typeof p.after_render && p.after_render(c, o))
            }).observe(document, {
                childList: !0,
                attributes: !1,
                characterData: !1,
                subtree: !0,
                attributeOldValue: !1,
                characterDataOldValue: !1
            }), jQuery(document).ajaxComplete(function (t, e, a) {
                "GET" == a.type && "/cart.js" == a.url && 200 == e.status && (afterpay_cart_total_price = e.responseJSON.total_price)
            }))
        })
    },
    initFooterLogo: function (o) {
        if ("boolean" == typeof afterpay_footer_logo_enabled && afterpay_footer_logo_enabled) {
            var a, r = null,
                p = null,
                e = null;
            if ("string" == typeof afterpay_footer_logo_container ? r = o(afterpay_footer_logo_container) : Afterpay.supportedTheme && Afterpay.supportedTheme.hasOwnProperty("footer") ? o.each(Afterpay.supportedTheme.footer, function (t, e) {
                    if (0 < (r = o(e.logo_container)).length) return !1
                }) : (o.each(Afterpay.supportedThemes, function (a, t) {
                    var e = new RegExp(a, "i");
                    if (e.test(afterpay_theme_name) && t.hasOwnProperty("footer") && (o.each(t.footer, function (t, e) {
                            if (0 < (r = o(e.logo_container)).length) return Afterpay.supportedTheme = Afterpay.supportedThemes[a], !1
                        }), "object" == typeof Afterpay.supportedTheme && null !== Afterpay.supportedTheme)) return !1
                }), Afterpay.supportedTheme && !0 !== Afterpay.supportedTheme || o.each(Afterpay.commonElements.footer.logo_container, function (t, e) {
                    if (0 < (r = o(e)).length) return !1
                })), 0 != r.length && 0 != r.children().length)
                if (["icon", "stacked", "logo"].includes(afterpay_footer_logo_format) && ["colour", "color", "black", "white"].includes(afterpay_footer_logo_theme) && ["border", "transparent"].includes(afterpay_footer_logo_background)) {
                    if (a = "https://static.afterpay.com/icon/afterpay-" + afterpay_footer_logo_format + "-" + afterpay_footer_logo_theme + "-" + (afterpay_footer_logo_background = "logo" == afterpay_footer_logo_format ? "transparent" : afterpay_footer_logo_background) + ".svg", "string" == typeof afterpay_footer_logo_template) p = o(afterpay_footer_logo_template.replace("{logo_path}", a));
                    else if (Afterpay.supportedTheme && Afterpay.supportedTheme.hasOwnProperty("footer")) o.each(Afterpay.supportedTheme.footer, function (t, e) {
                        p = o(e.logo_template.replace("{logo_path}", a))
                    });
                    else if ((p = r.children().first().clone()).is("svg") || p.is("img")) e = p.attr("class"), p = p.is("svg") ? o('<object class="' + e + '" data="' + a + '" type="image/svg+xml"></object>') : o('<img class="' + e + '" src="' + a + '" alt="afterpay" />');
                    else if (p.find("svg").length) e = p.find("svg").attr("class"), p.find("svg").replaceWith('<object class="' + e + '" data="' + a + '" type="image/svg+xml"></object>');
                    else {
                        if (!p.find("img").length) return;
                        e = p.find("img").attr("class"), p.find("img").replaceWith('<img class="' + e + '" src="' + a + '" alt="afterpay" />')
                    }
                    p.is("object") || p.find("object").length ? (e = (p.is("object") ? p : p.find("object")).attr("class"), o.get(a + "?co=1", function (t) {
                        p.is("object") ? ((p = o(t.documentElement)).addClass(e), "object" == typeof afterpay_footer_logo_css && p.css(afterpay_footer_logo_css)) : (p.find("object").replaceWith(t.documentElement), p.find("svg").addClass(e), "object" == typeof afterpay_footer_logo_css && p.find("svg").css(afterpay_footer_logo_css)), r.append(p)
                    })) : p.is("img") ? ("object" == typeof afterpay_footer_logo_css && p.css(afterpay_footer_logo_css), r.append(p)) : p.find("img").length && ("object" == typeof afterpay_footer_logo_css && p.find("img").css(afterpay_footer_logo_css), r.append(p))
                }
        }
    },
    initProductPage: function (r) {
        var t, o = null,
            p = null,
            c = null,
            e = "after",
            n = Afterpay.renderParagraph(r, {
                total_price: afterpay_current_variant.price,
                page_name: "product"
            });
        "undefined" != typeof afterpay_product_selector ? (Afterpay.supportedTheme = !0, 0 < (o = r(afterpay_product_selector)).length && (p = o.first())) : (Afterpay.supportedTheme ? r.each(Afterpay.supportedTheme.product, function (t, e) {
            if (0 < (o = r(e.selector)).length) return p = o.first(), e.paragraph_css && n.css(e.paragraph_css), $logo_element = n.find(".afterpay-logo"), 0 < $logo_element.length && e.logo_css && $logo_element.css(e.logo_css), !1
        }) : (o = null, r.each(Afterpay.supportedThemes, function (a, t) {
            var e = new RegExp(a, "i");
            if (e.test(afterpay_theme_name) && (r.each(Afterpay.supportedThemes[a].product, function (t, e) {
                    if (0 < (o = r(e.selector)).length) return Afterpay.supportedTheme = Afterpay.supportedThemes[a], p = o.first(), e.paragraph_css && n.css(e.paragraph_css), $logo_element = n.find(".afterpay-logo"), 0 < $logo_element.length && e.logo_css && $logo_element.css(e.logo_css), !1
                }), null !== p)) return !1
        })), null === p && r.each(Afterpay.commonElements.product.price_selector, function (t, e) {
            if (0 < (o = r(e)).length) return Afterpay.supportedTheme = !0, p = o.first(), !1
        }), null === p && 0 < (o = r('form[action^="/cart/add"]')).length && (p = o.first(), e = "before", "USD" == afterpay_shop_currency ? n.find(".afterpay-text1").html("Pay in 4 interest-free installments of ") : n.find(".afterpay-text1").html("Make 4 interest-free payments of "))), null !== p && (afterpay_current_variant.available ? (afterpay_current_variant.price < 100 * afterpay_min || afterpay_current_variant.price > 100 * afterpay_max) && ("USD" == afterpay_shop_currency ? n = Afterpay.generateOutsideLimitHTML(n) : n.hide()) : n.hide(), Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.6", ">=") && "after" == e && ("-" == (t = p.css("margin-bottom")).charAt(0) ? n.css("margin-top", t.slice(1)) : n.css("margin-top", "-" + t), n.css("margin-bottom", t)), "undefined" != typeof afterpay_product_css && n.css(afterpay_product_css), p[e](n)), 0 != afterpay_variable_price_fallback ? null !== (c = null === (c = "undefined" != typeof afterpay_variable_price_fallback_selector && 0 < (o = r(afterpay_variable_price_fallback_selector)).length ? o.first() : c) && null !== p ? p : c) && (Afterpay.mutationObserver && "mutation" == afterpay_variable_price_fallback_method ? (Afterpay.updateParagraph(n, Afterpay.extractPriceFromHTML(c.text())), new Afterpay.mutationObserver(function (t, e) {
            var a;
            for (c = r(afterpay_variable_price_fallback_selector).first(), a = 0; a < t.length; a++) r(t[a].target).is(c) && Afterpay.updateParagraph(n, Afterpay.extractPriceFromHTML(t[a].target.innerHTML))
        }).observe(document.body, {
            childList: !0,
            attributes: !1,
            characterData: !1,
            subtree: !0,
            attributeOldValue: !1,
            characterDataOldValue: !1
        })) : setInterval(function (t) {
            c = r(afterpay_variable_price_fallback_selector).first(), Afterpay.updateParagraph(n, Afterpay.extractPriceFromHTML(c.text()))
        }, 400)) : r("body").on("change", r('form[action^="/cart/add"]'), function (t) {
            var t = r(t.target).closest("form"),
                a = parseInt(r("input[name=id]:checked, select[name=id], input[name=id], hidden[name=id]", t).val(), 10),
                o = !1;
            !isNaN(a) && 0 < a && r.each(afterpay_product.variants, function (t, e) {
                e.id == a && e.available && (e.price >= 100 * afterpay_min && e.price <= 100 * afterpay_max ? (o = !0, (n = "USD" == afterpay_shop_currency ? Afterpay.generateInsideLimitHTML(n) : n).find(".afterpay-instalments").html(Afterpay.generateInstalmentHTML(e.price))) : "USD" == afterpay_shop_currency && (o = !0, n = Afterpay.generateOutsideLimitHTML(n)))
            }), t.find("input[type=submit],button[type=submit]").is("[disabled]") && (o = !1), null !== n && (o ? n.show() : n.hide())
        })
    },
    initStaticCartPage: function (o) {
        var r = null,
            p = null,
            c = null,
            t = "after",
            n = Afterpay.renderParagraph(o, {
                total_price: afterpay_cart_total_price,
                page_name: "static_cart"
            });
        "undefined" != typeof afterpay_cart_static_selector ? (Afterpay.supportedTheme = !0, 0 < (r = o(afterpay_cart_static_selector)).length && (p = r.first(), "USD" != afterpay_shop_currency && (n.find(".afterpay-text1").html("or 4 payments of "), n.find(".afterpay-text2").html(" with ")))) : (Afterpay.supportedTheme ? o.each(Afterpay.supportedTheme.cart.static_page, function (t, e) {
            if (r = o(e.selector), e.paragraph_css && n.css(e.paragraph_css), 0 < r.length) return p = r.first(), "USD" != afterpay_shop_currency && (n.find(".afterpay-text1").html("or 4 payments of "), n.find(".afterpay-text2").html(" with ")), $logo_element = n.find(".afterpay-logo"), 0 < $logo_element.length && e.logo_css && $logo_element.css(e.logo_css), !1
        }) : (r = null, o.each(Afterpay.supportedThemes, function (a, t) {
            var e = new RegExp(a, "i");
            if (e.test(afterpay_theme_name) && (o.each(Afterpay.supportedThemes[a].cart.static_page, function (t, e) {
                    if (r = o(e.selector), e.paragraph_css && n.css(e.paragraph_css), 0 < r.length) return Afterpay.supportedTheme = Afterpay.supportedThemes[a], p = r.first(), "USD" != afterpay_shop_currency && (n.find(".afterpay-text1").html("or 4 payments of "), n.find(".afterpay-text2").html(" with ")), $logo_element = n.find(".afterpay-logo"), 0 < $logo_element.length && e.logo_css && $logo_element.css(e.logo_css), !1
                }), null !== p)) return !1
        })), null === p && o.each(Afterpay.commonElements.cart.static_page.subtotal_selector, function (t, e) {
            if (0 < (r = o(e)).length) return Afterpay.supportedTheme = !0, p = r.first(), "USD" != afterpay_shop_currency && (n.find(".afterpay-text1").html("or 4 payments of "), n.find(".afterpay-text2").html(" with ")), !1
        }), null === p && (n.css({
            "text-align": "right"
        }), "USD" == afterpay_shop_currency ? n.find(".afterpay-text1").html("Pay in 4 interest-free installments of ") : n.find(".afterpay-text1").html("Make 4 payments of "), 0 < (r = o('a[href="collections/all"],input[name=update]')).length ? (p = r.first(), t = "before") : 0 < (r = o('form[action^="/cart"]:not(form[action^="/cart/add"])')).length && (p = r.first()))), null !== p && ((afterpay_cart_total_price < 100 * afterpay_min || afterpay_cart_total_price > 100 * afterpay_max) && ("USD" == afterpay_shop_currency ? n = Afterpay.generateOutsideLimitHTML(n) : n.hide()), "undefined" != typeof afterpay_cart_static_css && n.css(afterpay_cart_static_css), p[t](n)), 0 != afterpay_variable_subtotal_fallback && null !== (c = null === (c = "undefined" != typeof afterpay_variable_subtotal_fallback_selector && 0 < (r = o(afterpay_variable_subtotal_fallback_selector)).length ? r.first() : c) && null !== p ? p : c) && (Afterpay.mutationObserver && "mutation" == afterpay_variable_subtotal_fallback_method ? (Afterpay.updateParagraph(n, Afterpay.extractPriceFromHTML(c.text())), new Afterpay.mutationObserver(function (t, e) {
            var a;
            for (c = o(afterpay_variable_subtotal_fallback_selector).first(), a = 0; a < t.length; a++) o(t[a].target).is(c) && Afterpay.updateParagraph(n, Afterpay.extractPriceFromHTML(t[a].target.innerHTML))
        }).observe(c.get(0), {
            childList: !0,
            attributes: !1,
            characterData: !1,
            subtree: !0,
            attributeOldValue: !1,
            characterDataOldValue: !1
        })) : setInterval(function (t) {
            c = o(afterpay_variable_subtotal_fallback_selector).first(), Afterpay.updateParagraph(n, Afterpay.extractPriceFromHTML(c.text()))
        }, 400))
    },
    launchPopup: function (a, o) {
        if (o.preventDefault(), afterpay_modal_responsive) {
            if ("USD" == afterpay_shop_currency) var t = "https://static.afterpay.com/modal/us.css",
                e = "https://static.afterpay.com/modal/us.html";
            else {
                if ("CAD" != afterpay_shop_currency) return;
                t = "https://static.afterpay.com/modal/ca.css", e = "https://static.afterpay.com/modal/ca.html"
            }
            var r;
            a("#afterpay-modal-container").length ? (a("body").addClass("afterpay-modal-open"), a("#afterpay-modal-modal").scrollTop(0)) : ((r = a(document.createElement("link"))).attr("rel", "stylesheet").attr("type", "text/css").attr("href", t).appendTo("head"), a.ajax({
                url: e,
                complete: function (t, e) {
                    200 == t.status ? (a("body").addClass("afterpay-modal-open").append(t.responseText), a("#afterpay-afterpay-modal-close").on("click", function (t) {
                        t.preventDefault(), a("body").removeClass("afterpay-modal-open")
                    })) : (r.remove(), afterpay_modal_responsive = !1, Afterpay.launchPopup(a, o))
                }
            }))
        } else {
            var p = a("#afterpay-popup-wrapper");
            0 < p.length ? p.show() : (p = a(document.createElement("div")).attr("id", "afterpay-popup-wrapper").css({
                position: "fixed",
                "z-index": 9999999999,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                overflow: "auto"
            }).appendTo("body").on("click", function (t) {
                Afterpay.closePopup(a, t)
            }), t = a(document.createElement("div")).attr("id", "afterpay-popup-outer").css({
                display: "flex",
                "-webkit-justify-content": "center",
                "-ms-flex-pack": "center",
                "justify-content": "center",
                "-webkit-align-content": "center",
                "-ms-flex-line-pack": "center",
                "align-content": "center",
                "-webkit-align-items": "center",
                "-ms-flex-align": "center",
                "align-items": "center",
                width: "100%",
                "min-height": "100%",
                "background-color": "rgba(0, 0, 0, 0.80)"
            }).appendTo(p), e = a(document.createElement("div")).attr("id", "afterpay-popup-inner").css({
                position: "relative",
                "background-color": "#fff"
            }).appendTo(t), p = a(document.createElement("a")), "USD" == afterpay_shop_currency ? p.attr("href", "https://www.afterpay.com/installment-agreement") : p.attr("href", "https://www.afterpay.com/terms"), p.attr("target", "_blank").css({
                display: "block"
            }).appendTo(e), t = a(document.createElement("img")), "USD" == afterpay_shop_currency ? 640 < a(window).width() ? t.attr("src", "https://static.afterpay.com/us-popup-medium.png").attr("srcset", "https://static.afterpay.com/us-popup-medium.png 1x, https://static.afterpay.com/us-popup-medium@2x.png 2x").css({
                "max-width": "597px"
            }) : t.attr("src", "https://static.afterpay.com/us-popup-small.png").attr("srcset", "https://static.afterpay.com/us-popup-small.png 1x, https://static.afterpay.com/us-popup-small@2x.png 2x").css({
                "max-width": "299px"
            }) : afterpay_cbt_enabled ? 640 < a(window).width() ? t.attr("src", "https://static.afterpay.com/lightbox-desktop-cbt.png").attr("srcset", "https://static.afterpay.com/lightbox-desktop-cbt.png 1x, https://static.afterpay.com/lightbox-desktop-cbt@2x.png 2x, https://static.afterpay.com/lightbox-desktop-cbt@3x.png 3x").css({
                "max-width": "597px"
            }) : t.attr("src", "https://static.afterpay.com/lightbox-mobile-cbt.png").attr("srcset", "https://static.afterpay.com/lightbox-mobile-cbt.png 1x, https://static.afterpay.com/lightbox-mobile-cbt@2x.png 2x, https://static.afterpay.com/lightbox-mobile-cbt@3x.png 3x").css({
                "max-width": "300px"
            }) : 640 < a(window).width() ? t.attr("src", "https://static.afterpay.com/lightbox-desktop.png") : t.attr("src", "https://static.afterpay.com/lightbox-mobile.png"), t.css({
                display: "block",
                width: "100%"
            }).appendTo(p).on("click", function (t) {
                t.stopPropagation()
            }), a(document.createElement("a")).attr("href", "#").css({
                position: "absolute",
                right: "8px",
                top: "8px"
            }).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" version="1.1" width="32px" height="32px"><g id="surface1"><path style=" " d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z "/></g></svg>').appendTo(e).on("click", function (t) {
                Afterpay.closePopup(a, t)
            }))
        }
    },
    loadScript: function (t, e) {
        var a = document.createElement("script");
        a.type = "text/javascript", a.readyState ? a.onreadystatechange = function () {
            "loaded" != a.readyState && "complete" != a.readyState || (a.onreadystatechange = null, e())
        } : a.onload = function () {
            e()
        }, a.src = t, document.getElementsByTagName("head")[0].appendChild(a)
    },
    renderParagraph: function (e, t) {
        var a = e(document.createElement("p")).addClass("afterpay-paragraph");
        null !== afterpay_product && a.attr("data-product-id", afterpay_product.id);
        var o = e(document.createElement("span")).addClass("afterpay-text1").appendTo(a);
        "USD" == afterpay_shop_currency || "CAD" == afterpay_shop_currency ? o.html("4 payments of ") : o.html("4 payments of ");
        e(document.createElement("strong")).addClass("afterpay-instalments").html(Afterpay.generateInstalmentHTML(t.total_price)).appendTo(a);
        o = e(document.createElement("span")).addClass("afterpay-text2").appendTo(a);
        "USD" == afterpay_shop_currency || "CAD" == afterpay_shop_currency ? o.html(" with ") : o.html(" with ");
        o = afterpay_logo_theme;
        "product" == t.page_name && "undefined" != typeof afterpay_product_logo_theme ? o = afterpay_product_logo_theme : "static_cart" == t.page_name && "undefined" != typeof afterpay_cart_static_logo_theme ? o = afterpay_cart_static_logo_theme : "dynamic_cart" == t.page_name && "undefined" != typeof afterpay_cart_dynamic_logo_theme && (o = afterpay_cart_dynamic_logo_theme);
        e(document.createElement("img")).addClass("afterpay-logo").css({
            "vertical-align": "middle",
            width: "100px",
            border: "0px"
        }).attr("src", "https://static.afterpay.com/integration/product-page/logo-afterpay-" + o + ".png").attr("srcset", "https://static.afterpay.com/integration/product-page/logo-afterpay-" + o + ".png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-" + o + "@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-" + o + "@3x.png 3x").attr("width", "100").attr("height", "21").attr("alt", "Afterpay").appendTo(a), e(document.createElement("span")).addClass("afterpay-text3").html("&nbsp;").appendTo(a);
        o = e(document.createElement("a")).addClass("afterpay-link");
        "USD" == afterpay_shop_currency ? o.attr("href", "https://www.afterpay.com/installment-agreement") : "CAD" == afterpay_shop_currency ? o.attr("href", "https://www.afterpay.com/en-CA/instalment-agreement") : o.attr("href", "https://www.afterpay.com/terms"), o.attr("target", "_blank").on("click", function (t) {
            Afterpay.launchPopup(e, t)
        }).appendTo(a);
        e(document.createElement("u")).addClass("afterpay-link-inner").css({
            "font-size": "12px"
        }).html(afterpay_modal_open_icon ? "â“˜" : '<i class="fa fa-info-circle" aria-hidden="true"></i>').css(afterpay_modal_open_icon ? {
            "text-decoration": "none"
        } : {
            "text-decoration": "underline"
        }).appendTo(o);
        return a
    },
    supportedCurrencies: ["AUD", "NZD", "USD", "CAD"],
    supportedThemes: {
        alchemy: {
            product: {
                "2017-12-14": {
                    selector: ".quadd-wrapper"
                },
                "2021-08-13": {
                    selector: ".product-price"
                }
            },
            cart: {
                static_page: {
                    "2021-08-13": {
                        selector: "div.column.half.align-right.align-center-mobile > div.h2"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer div.payment-methods__inner",
                    logo_template: '<img class="payment-icon fade-in lazyloaded" alt="afterpay" src="{logo_path}">'
                }
            }
        },
        atlantic: {
            product: {
                "2017-12-14": {
                    selector: "p.price"
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-options",
                    logo_template: '<li class="payment-icon"><object data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        blockshop: {
            product: {
                "2017-12-14": {
                    selector: "article .prices",
                    paragraph_css: {
                        "margin-top": "-1em",
                        "margin-bottom": "2em"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons--list",
                    logo_template: '<li class="payment-icons--item"><object data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        boundless: {
            product: {
                "2017-12-14": {
                    selector: "#AddToCartForm-product-template .product__price",
                    paragraph_css: {
                        "margin-top": "0px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: "span.cart__subtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="payment-icons__icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        brooklyn: {
            product: {
                "2017-12-14": {
                    selector: "#ProductPrice",
                    logo_css: {
                        border: "0px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: ".cart__row--table:last",
                        logo_css: {
                            border: "0px"
                        }
                    }
                },
                dynamic_content: {
                    "2018-06-25": {
                        target_selector: "#CartDrawer #CartContainer",
                        addedNode_selector: "form.ajaxcart",
                        subtotal_selector: ".ajaxcart__footer .grid--full",
                        paragraph_css: {
                            "text-align": "right"
                        },
                        logo_css: {
                            border: "0px"
                        },
                        after_render: function (t, e) {
                            var a = t("#CartContainer .ajaxcart__inner--has-fixed-footer"),
                                t = t("#CartContainer .ajaxcart__footer--fixed"),
                                e = t.outerHeight() + e.outerHeight(!0);
                            a.css("bottom", e + "px"), t.css("height", e + "px")
                        }
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        classic: {
            product: {
                "2017-12-14": {
                    selector: ".product-single__prices",
                    paragraph_css: {
                        "margin-top": "-15px",
                        "margin-bottom": "30px"
                    }
                }
            }
        },
        debutify: {
            product: {
                "2020-09-17": {
                    selector: ".price-wrapper"
                },
                "2021-08-13": {
                    selector: ".price-container"
                }
            },
            cart: {
                static_page: {
                    "2020-09-17": {
                        selector: ".cart__row--table:last",
                        paragraph_css: {
                            "text-align": "center"
                        }
                    },
                    "2021-11-04": {
                        selector: ".card-body > div.grid.grid-small.flex-nowrap",
                        paragraph_css: {
                            "text-align": "center"
                        }
                    },
                    "2021-11-05": {
                        selector: ".cart__total-price-info",
                        paragraph_css: {
                            "text-align": "center"
                        }
                    }
                }
            },
            footer: {
                "2020-09-17": {
                    logo_container: ".payment-icons-list",
                    logo_template: '<li><object class="payment-icons" data="{logo_path}" type="image/svg+xml"></object></li>'
                },
                "2021-11-05": {
                    logo_container: "footer .payment-icons ul",
                    logo_template: '<li><object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        debut: {
            product: {
                "2017-12-14": {
                    selector: ".product-single__price",
                    paragraph_css: {
                        "margin-top": "-20px",
                        "margin-bottom": "40px"
                    }
                },
                "2018-07-04": {
                    selector: ".product__price",
                    paragraph_css: {
                        "margin-top": "-10px",
                        "margin-bottom": "40px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: ".cart__footer .cart__subtotal"
                    },
                    "2020-03-27": {
                        selector: ".cart-subtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li class="payment-icon"><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        district: {
            product: {
                "2017-12-14": {
                    selector: "#ComparePrice-product-template",
                    paragraph_css: {
                        "margin-top": "0.3rem",
                        display: "block",
                        "font-style": "normal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer .payment-types ul",
                    logo_template: '<li><object class="payment-icon payment-icon--afterpay" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        empire: {
            product: {
                "2017-12-14": {
                    selector: ".product--container .product-pricing",
                    paragraph_css: {
                        "line-height": "1.5",
                        "margin-top": "10px",
                        "margin-bottom": "22px"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li class="payment-icons-item"><object data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        fashionopolism: {
            product: {
                "2017-12-14": {
                    selector: ".product-prices"
                },
                "2018-08-10": {
                    selector: "#product-price"
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: "#basket-right>h4"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer .sub-footer .right-side",
                    logo_template: '<img src="{logo_path}" />'
                }
            }
        },
        flow: {
            product: {
                "2017-12-14": {
                    selector: "#ProductPrice",
                    paragraph_css: {
                        "margin-top": "-20px",
                        "margin-bottom": "30px"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        grid: {
            product: {
                "2017-12-14": {
                    selector: ".product-details .product-price",
                    paragraph_css: {
                        "margin-top": "-35px",
                        "margin-bottom": "40px"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer .site-footer-payment-types",
                    logo_template: '<object data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        icon: {
            product: {
                "2017-12-14": {
                    selector: "#product-price",
                    paragraph_css: {
                        "margin-top": "-20px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: "#basket-right>h4"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer #payment",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        jumpstart: {
            product: {
                "2017-12-14": {
                    selector: "#AddToCartForm .price:last"
                },
                "2018-05-30": {
                    selector: "#ProductPrice-product-template"
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: "span.h3.cart__subtotal"
                    }
                }
            }
        },
        minimal: {
            product: {
                "2017-12-14": {
                    selector: ".product-single__prices",
                    paragraph_css: {
                        "margin-top": "-15px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: ".h5.cart__subtotal"
                    },
                    "2020-02-26": {
                        selector: ".cart__subtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        modular: {
            product: {
                "2017-12-14": {
                    selector: ".productForm .product-price",
                    paragraph_css: {
                        "margin-top": "-1rem",
                        "margin-bottom": "1.5rem"
                    }
                },
                "2020-06-03": {
                    selector: ".product-normal-price"
                },
                "2020-09-21": {
                    selector: ".product-price"
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icon-list",
                    logo_template: '<li><object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        motion: {
            product: {
                "2017-12-14": {
                    selector: ".product-single__meta .product__price:last"
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: ".grid--full.cart__row--table:last",
                        paragraph_css: {
                            "margin-top": "10px"
                        }
                    }
                }
            }
        },
        narrative: {
            product: {
                "2017-12-14": {
                    selector: ".product__content .product__price",
                    paragraph_css: {
                        "margin-top": "0px",
                        "text-align": "center"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: ".cart-footer .cart-footer__subtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li class="payment-icon"><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        pacific: {
            product: {
                "2017-12-14": {
                    selector: ".product-price"
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer .payment-options",
                    logo_template: '<object data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        parallax: {
            product: {
                "2017-12-14": {
                    selector: ".modal_price"
                }
            },
            cart: {
                static_page: {
                    "2018-05-31": {
                        selector: "form .subtotal_amount",
                        paragraph_css: {
                            "font-size": "13px"
                        }
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: ".footer .payment_methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        pipeline: {
            product: {
                "2017-12-14": {
                    selector: "#ComparePriceWrapper-product",
                    paragraph_css: {
                        "margin-top": "15px",
                        "line-height": "1.5",
                        "letter-spacing": "0",
                        "font-size": "14px",
                        "text-transform": "none",
                        color: "#000"
                    }
                },
                "2018-08-10": {
                    selector: "#productInfo-product .product__price"
                },
                "2021-08-13": {
                    selector: ".product__price"
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: ".cart__footer__text:first"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object><span class="visually-hidden">Afterpay</span></li>'
                }
            }
        },
        pop: {
            product: {
                "2017-12-14": {
                    selector: ".product-single__price"
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: "span.cart__subtotal"
                    }
                }
            }
        },
        prestige: {
            product: {
                "2018-07-27": {
                    selector: ".ProductMeta__PriceList.Heading"
                }
            },
            cart: {
                static_page: {
                    "2021-04-01": {
                        selector: ".Cart__Total.Heading.u-h6"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.Footer__PaymentList",
                    logo_template: '<li class="HorizontalList__Item"><object data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        providence: {
            product: {
                "2017-12-14": {
                    selector: ".pricing"
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer .payment-types",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        retina: {
            product: {
                "2017-12-14": {
                    selector: ".modal_price",
                    paragraph_css: {
                        "margin-top": "-15px",
                        "margin-bottom": "20px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: "#cart_form .subtotal_amount",
                        paragraph_css: {
                            "font-size": "13px"
                        }
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: ".footer .payment_methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        showcase: {
            product: {
                "2018-08-10": {
                    selector: ".product-detail__title-and-price .price-area"
                },
                "2021-08-13": {
                    selector: ".product-area__row",
                    paragraph_css: {
                        "text-align": "left"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: "#cartform .subtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: ".page-footer ul.payment-methods",
                    logo_template: '<li><object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                },
                "2021-08-13": {
                    logo_container: ".section-footer__payment-icons",
                    logo_template: '<object class="section-footer__payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        showtime: {
            product: {
                "2017-12-14": {
                    selector: ".desc_blk_bot .price",
                    paragraph_css: {
                        float: "none",
                        clear: "both",
                        "margin-bottom": "1rem",
                        "text-align": "center"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "#footer .partner ul.list-inline",
                    logo_template: '<li><object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        simple: {
            product: {
                "2017-12-14": {
                    selector: "#ProductSection .product-single__prices",
                    paragraph_css: {
                        "margin-top": "-15px",
                        "margin-bottom": "30px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: "span.cart__subtotal.h3"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        supply: {
            product: {
                "2017-12-14": {
                    selector: "ul.product-meta"
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: ".h1.cart-subtotal--price"
                    }
                },
                dynamic_content: {
                    "2018-05-30": {
                        target_selector: "#ajaxifyCart.ajaxifyCart--content",
                        addedNode_selector: "form.cart-form",
                        subtotal_selector: ".h1.cart-subtotal--price"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        symmetry: {
            product: {
                "2017-12-14": {
                    selector: "#main-product-detail .price-area"
                },
                "2021-08-13": {
                    selector: ".price-container"
                }
            },
            cart: {
                static_page: {
                    "2021-08-13": {
                        selector: ".subtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "#pagefooter .payment-methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                },
                "2021-08-13": {
                    logo_container: ".section-footer__payment-icons",
                    logo_template: '<object class="section-footer__payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        testament: {
            product: {
                "2017-12-14": {
                    selector: "#product-price"
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: "#basket-right>h4"
                    }
                }
            },
            footer: {
                "2020-06-03": {
                    logo_container: "footer #payment",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        turbo: {
            product: {
                "2018-08-10": {
                    selector: ".modal_price"
                }
            },
            cart: {
                static_page: {
                    "2018-08-10": {
                        selector: "#cart_form .cart_subtotal"
                    }
                }
            },
            footer: {
                "2020-06-03": {
                    logo_container: ".payment_methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        venture: {
            product: {
                "2017-12-14": {
                    selector: "ul.product-single__meta-list",
                    paragraph_css: {
                        "margin-top": "10px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2018-05-30": {
                        selector: "p#CartSubtotal"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        venue: {
            product: {
                "2017-12-14": {
                    selector: "h3.product-single__price-text",
                    paragraph_css: {
                        "line-height": "1.5"
                    }
                }
            },
            footer: {
                "2020-02-07": {
                    logo_container: "footer ul.footer__icons-items",
                    logo_template: '<li class="footer__icons-item"><object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        responsive: {
            product: {
                "2020-03-05": {
                    selector: ".product_section p.modal_price",
                    paragraph_css: {
                        "margin-top": "-10px",
                        "margin-bottom": "10px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2020-03-05": {
                        selector: "#cart_form > .columns.omega > h4"
                    }
                }
            },
            footer: {
                "2020-03-05": {
                    logo_container: "footer div.payment_methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        canopy: {
            product: {
                "2020-03-10": {
                    selector: "#price"
                }
            },
            cart: {
                static_page: {
                    "2020-03-10": {
                        selector: "#cartform div.cart-subtotal"
                    }
                }
            },
            footer: {
                "2020-03-10": {
                    logo_container: "footer div.payment-methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        sunrise: {
            product: {
                "2020-03-26": {
                    selector: ".product-details .product-price-wrap",
                    paragraph_css: {
                        "font-size": "16px"
                    }
                }
            },
            footer: {
                "2020-03-26": {
                    logo_container: "footer .payment-icons",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        impulse: {
            product: {
                "2020-04-06": {
                    selector: ".product__price-savings"
                }
            },
            cart: {
                static_page: {
                    "2021-04-01": {
                        selector: ".main-content .cart__item-sub.cart__item-row",
                        paragraph_css: {
                            "text-align": "center"
                        }
                    }
                }
            },
            footer: {
                "2020-04-06": {
                    logo_container: "footer ul.payment-icons",
                    logo_template: '<li class="icon--payment"><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        ella: {
            product: {
                "2020-06-03": {
                    selector: ".prices"
                }
            },
            cart: {
                static_page: {
                    "2020-06-03": {
                        selector: ".total",
                        paragraph_css: {
                            "text-align": "center",
                            "margin-bottom": "15px"
                        }
                    }
                }
            }
        },
        kingdom: {
            product: {
                "2020-06-03": {
                    selector: ".product__price--original"
                },
                "2020-09-21": {
                    selector: ".product__price--compare"
                }
            },
            cart: {
                static_page: {
                    "2020-06-03": {
                        selector: "#CartTotal",
                        paragraph_css: {
                            margin: "-5px 0 3px"
                        }
                    }
                }
            }
        },
        caros: {
            product: {
                "2020-06-03": {
                    selector: ".total-price"
                }
            },
            cart: {
                static_page: {
                    "2020-06-03": {
                        selector: ".total",
                        paragraph_css: {
                            "text-align": "center"
                        }
                    }
                }
            }
        },
        furnitica: {
            product: {
                "2020-06-03": {
                    selector: ".prices"
                }
            },
            cart: {
                static_page: {
                    "2020-06-03": {
                        selector: ".total-price"
                    }
                }
            }
        },
        maker: {
            footer: {
                "2020-06-03": {
                    logo_container: ".payment-icons--list",
                    logo_template: '<li class="payment-icons--item"><object class="" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        molla: {
            product: {
                "2020-06-03": {
                    selector: ".gf_product-prices",
                    paragraph_css: {
                        "margin-bottom": "20px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2020-06-03": {
                        selector: ".table-summary",
                        paragraph_css: {
                            "text-align": "center"
                        }
                    }
                }
            }
        },
        vantage: {
            cart: {
                static_page: {
                    "2020-06-03": {
                        selector: "#basket-right > h4"
                    }
                }
            },
            footer: {
                "2020-06-03": {
                    logo_container: ".payment-methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        envy: {
            product: {
                "2020-09-17": {
                    selector: ".product-page--pricing"
                }
            },
            cart: {
                static_page: {
                    "2020-09-17": {
                        selector: ".cart-totals--wrapper",
                        paragraph_css: {
                            "text-align": "right"
                        }
                    }
                }
            },
            footer: {
                "2020-09-17": {
                    logo_container: "#footer-payment-methods",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        vanisa: {
            product: {
                "2020-09-21": {
                    selector: ".product-price",
                    paragraph_css: {
                        "margin-top": "-5px",
                        "margin-bottom": "15px"
                    }
                }
            },
            cart: {
                static_page: {
                    "2020-09-21": {
                        selector: ".total-checkout"
                    }
                }
            }
        },
        streamline: {
            product: {
                "2020-09-21": {
                    selector: ".product-single__prices"
                }
            },
            cart: {
                static_page: {
                    "2021-04-01": {
                        selector: ".h3.cart__subtotal"
                    }
                }
            },
            footer: {
                "2020-09-21": {
                    logo_container: ".payment-icons",
                    logo_template: '<li class="icon--payment"><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        editions: {
            product: {
                "2020-09-21": {
                    selector: ".product-details__price-container"
                }
            },
            footer: {
                "2020-09-21": {
                    logo_container: ".payment-options",
                    logo_template: '<object class="payment-icons" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        warehouse: {
            product: {
                "2020-09-21": {
                    selector: ".product-form .price-list"
                }
            },
            cart: {
                static_page: {
                    "2020-09-21": {
                        selector: ".cart-recap__price-line"
                    }
                }
            },
            footer: {
                "2020-09-21": {
                    logo_container: ".payment-list",
                    logo_template: '<object class="payment-list__item" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        broadcast: {
            product: {
                "2021-08-13": {
                    selector: ".product__price__wrap"
                }
            },
            cart: {
                static_page: {
                    "2021-08-13": {
                        selector: "#MainContent > div > div > form > div.cart__inner > div.cart__aside > div:nth-child(4)"
                    }
                }
            }
        },
        lorenza: {
            product: {
                "2021-08-13": {
                    selector: "div.product__header:visible > div.product__price, div.product__mobile-header:visible > div.product__price"
                }
            },
            cart: {
                static_page: {
                    "2021-08-13": {
                        selector: "p.type-body-extra-large.type-heading-1-small.mt1.mb1"
                    }
                }
            }
        },
        expression: {
            product: {
                "2021-08-13": {
                    selector: ".product-price"
                }
            },
            footer: {
                "2021-08-13": {
                    logo_container: ".cards",
                    logo_template: '<object class="payment-icon" data="{logo_path}" type="image/svg+xml"></object>'
                }
            }
        },
        trademark: {
            product: {
                "2021-08-13": {
                    selector: ".product__prices:visible"
                }
            },
            cart: {
                static_page: {
                    "2021-08-13": {
                        selector: "div.grid div > span.cart__total.h3"
                    }
                }
            },
            footer: {
                "2021-08-13": {
                    logo_container: ".footer__payment-methods",
                    logo_template: '<li class="footer__payment-method"><object data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        elomus: {
            product: {
                "2021-08-13": {
                    selector: ".gf_product-prices",
                    paragraph_css: {
                        "margin-bottom": "15px"
                    }
                }
            }
        },
        dawn: {
            product: {
                "2021-11-05": {
                    selector: ".product__info-container .no-js-hidden"
                }
            },
            cart: {
                static_page: {
                    "2021-11-05": {
                        selector: "div.totals",
                        paragraph_css: {
                            "text-align": "right"
                        }
                    }
                }
            },
            footer: {
                "2021-11-05": {
                    logo_container: ".list-payment",
                    logo_template: '<li class="list-payment__item"><object class="icon icon--full-color" data="{logo_path}" type="image/svg+xml"></object></li>'
                }
            }
        },
        artisan: {
            cart: {
                static_page: {
                    "2021-12-10": {
                        selector: ".cart_subtotal"
                    }
                }
            }
        }
    },
    updateParagraph: function (t, e) {
        100 * afterpay_min <= e && e <= 100 * afterpay_max ? (t.show(), (t = "USD" == afterpay_shop_currency ? Afterpay.generateInsideLimitHTML(t) : t).find(".afterpay-instalments").html(Afterpay.generateInstalmentHTML(e))) : "USD" == afterpay_shop_currency ? (t.show(), t = Afterpay.generateOutsideLimitHTML(t)) : t.hide()
    }
};
Afterpay.versionCompare = function (t, e, a) {
    function o(t) {
        return (t = (t = ("" + t).replace(/[_\-+]/g, ".")).replace(/([^.\d]+)/g, ".$1.").replace(/\.{2,}/g, ".")).length ? t.split(".") : [-8]
    }

    function r(t) {
        return t ? isNaN(t) ? i[t] || -7 : parseInt(t, 10) : 0
    }
    var p, c, n = 0,
        i = {
            dev: -6,
            alpha: -5,
            a: -5,
            beta: -4,
            b: -4,
            RC: -3,
            rc: -3,
            "#": -2,
            p: 1,
            pl: 1
        };
    for (t = o(t), e = o(e), c = Math.max(t.length, e.length), p = 0; p < c; p++)
        if (t[p] !== e[p]) {
            if (t[p] = r(t[p]), e[p] = r(e[p]), t[p] < e[p]) {
                n = -1;
                break
            }
            if (t[p] > e[p]) {
                n = 1;
                break
            }
        }
    if (!a) return n;
    switch (a) {
        case ">":
        case "gt":
            return 0 < n;
        case ">=":
        case "ge":
            return 0 <= n;
        case "<=":
        case "le":
            return n <= 0;
        case "===":
        case "=":
        case "eq":
            return 0 === n;
        case "<>":
        case "!==":
        case "ne":
            return 0 !== n;
        case "":
        case "<":
        case "lt":
            return n < 0;
        default:
            return null
    }
};
var afterpay_product_integration_enabled, afterpay_cart_integration_enabled, afterpay_cart_dynamic_integration_enabled, afterpay_variable_price_fallback, afterpay_variable_subtotal_fallback, afterpay_modal_responsive, afterpay_show_currency_code, afterpay_hide_range_decimals, afterpay_hide_upper_limit, afterpay_hide_lower_limit, afterpay_modal_open_icon, afterpay_min, afterpay_max, afterpay_logo_theme, afterpay_cbt_enabled, afterpay_footer_logo_enabled, afterpay_footer_logo_format, afterpay_footer_logo_theme, afterpay_footer_logo_background, afterpay_js_include_version = "1.6.15";
void 0 === afterpay_product_integration_enabled && (afterpay_product_integration_enabled = !0), void 0 === afterpay_cart_integration_enabled && (afterpay_cart_integration_enabled = !("USD" != afterpay_shop_currency && !Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.12", ">="))), void 0 === afterpay_cart_dynamic_integration_enabled && (afterpay_cart_dynamic_integration_enabled = !1), void 0 === afterpay_variable_price_fallback && (afterpay_variable_price_fallback = "undefined" != typeof afterpay_variable_price_fallback_selector), "undefined" == typeof afterpay_variable_price_fallback_method && (afterpay_variable_price_fallback_method = "mutation"), void 0 === afterpay_variable_subtotal_fallback && (afterpay_variable_subtotal_fallback = "undefined" != typeof afterpay_variable_subtotal_fallback_selector), "undefined" == typeof afterpay_variable_subtotal_fallback_method && (afterpay_variable_subtotal_fallback_method = "mutation"), void 0 === afterpay_modal_responsive && (afterpay_modal_responsive = !("USD" != afterpay_shop_currency || !Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.2", ">="))), "CAD" == afterpay_shop_currency && (afterpay_modal_responsive = !0), void 0 === afterpay_show_currency_code && (afterpay_show_currency_code = "USD" != afterpay_shop_currency || !Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.2", ">=")), void 0 === afterpay_hide_range_decimals && (afterpay_hide_range_decimals = !!Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.2", ">=")), void 0 === afterpay_hide_upper_limit && (afterpay_hide_upper_limit = !!Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.2", ">=")), void 0 === afterpay_hide_lower_limit && (afterpay_hide_lower_limit = !1), void 0 === afterpay_modal_open_icon && (afterpay_modal_open_icon = !1), afterpay_min = void 0 === afterpay_min ? .04 : Math.max(afterpay_min, .04), "USD" == afterpay_shop_currency && (afterpay_min = Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.4", ">=") ? Math.max(afterpay_min, 1) : Math.max(afterpay_min, 35)), void 0 === afterpay_max ? afterpay_max = "USD" == afterpay_shop_currency ? 1e3 : 2e3 : Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.6", "<=") && "USD" != afterpay_shop_currency && (afterpay_max = 2e3), void 0 === afterpay_logo_theme && (afterpay_logo_theme = "colour"), void 0 === afterpay_cbt_enabled && (afterpay_cbt_enabled = !1), void 0 === afterpay_footer_logo_enabled && (afterpay_footer_logo_enabled = !!Afterpay.versionCompare(afterpay_js_snippet_version, "1.0.5", ">=")), void 0 === afterpay_footer_logo_format && (afterpay_footer_logo_format = "icon"), void 0 === afterpay_footer_logo_theme && (afterpay_footer_logo_theme = "colour"), void 0 === afterpay_footer_logo_background && (afterpay_footer_logo_background = "border"), Afterpay.arrayContainsElement(Afterpay.supportedCurrencies, afterpay_shop_currency) && ("function" != typeof jQuery || !Object.prototype.hasOwnProperty.call(jQuery, "fn") || Afterpay.versionCompare(jQuery.fn.jquery, "3.0", "<") ? Afterpay.loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js", function () {
    Afterpay.jQuery_3_4_1 = jQuery.noConflict(!0), Afterpay.init(Afterpay.jQuery_3_4_1)
}) : Afterpay.init(jQuery));